<div class="flex flex-col justify-center items-center h-[100dvh] bg-[#432EA7]">
    <h1 class="text-[30px] text-white">You have been logged out.</h1>
    <p><a class="text-white hover:text-[blue]" href="https://platform.kite-dev.gamithyatech.com/oauth2/authorization/keycloak">Click here to log in again</a>
</div>